import React from 'react';
import '../TermsAndConditionsPage/Styles.css';
import useTitle from '../../useTitle';
import ContactSection from '../../components/ContactSectionPage/Index';

const TermsAndConditions = () => {
    useTitle("Terms and Conditions")
  return (
    <>
        <div className='termsAndConditionsContainer'>
            <div className='termsAndConditionsSection'>
                <div className='termsAndConditionsTitleSection'>
                    <h1 className='termsAndConditionsTitle'>Terms and Conditions</h1>
                </div>
                <div className='termsAndConditionsDescriptionSection'>
                    <b className='termsAndConditionsDescriptionTitle'>Pricing:</b>
                    <p className='termsAndConditionsDescriptionText'>All prices are incl. VAT.</p>
                    <b className='termsAndConditionsDescriptionTitle'>Warranty:</b>
                    <ul className='warrantyDetails'>
                        <li><b>18kt gold jewelry</b>: 2 year warranty on fabrication and/or material defaults.</li>
                        <li><b>Sterling silver jewelry</b>: 6 month warranty on fabrication and/or material defaults.</li>
                        <li>Warranty expires on damages and/or deformations due to (probable) mishandling and/or improper care.</li>
                        <li>Warranty expires in case of damage due to the use of incorrect (cleaning) products.</li>
                        <li>Warranty expires if third party repairs have been carried out.</li>
                        <li>No warranty on damaged or lost gemstones.</li>
                    </ul>
                </div>
            </div>
        </div>
        <ContactSection />
    </>
  )
}

export default TermsAndConditions;
